jQuery( document ).ready(function() {

  // Create "collapsed" versions of elements
  // jQuery('.hero-inner .hero-inner-container').append(function() {
  //   var title = jQuery(this).find('.hero-heading').text();
  //   return '<div class="hero-content-collapsed"><h4 class="heading-title-small">' + title + '</h4></div>';
  // });

//   // Add the "Active" class to the every first carousel item
  jQuery('.mobile-hero .carousel-item').first().addClass('active');
  jQuery('.carousel-indicators .slide-indicator').first().addClass('active');
  jQuery('.desktop-hero .hero-item').first().addClass('active');

  // Add the "Active" class to the every first carousel item
  jQuery('.hero-inner .hero-item').click(function() {
    jQuery('.hero-inner .hero-item').removeClass('active');
    jQuery(this).addClass('active');
  });
});
